import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';

export const orderProductsByOnSale = (
  products: ProductVariantExtended[],
): ProductVariantExtended[] => {

  return [...products].sort(
    (productA, productB) => Number(!!productB?.price?.discounted) - Number(!!productA?.price?.discounted),
  );

};
